import React, { useEffect, useState } from 'react';
import Navbar from './Navbar/Navbar';
import './Layout.css';
import { useDispatch } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { setAuthorizationToken } from '../../utils/api-service/api-service';
import Cookies from 'js-cookie';
import AppNavbar from './Navbar/Navbar';
import { useTheme } from '../context/ThemeContext';

const Layout = ({ children }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isDarkMode } = useTheme();
    const [loading, setLoading] = useState(true);

    const returnJWT = async () => {
        let token = await Cookies.get('jwt');
        return token || null;
    }

    const auth = async () => {
        const isAuthenticated = await returnJWT();
        if (isAuthenticated) {
            setAuthorizationToken(isAuthenticated);
        } else {
            navigate('/login');
        }
        setLoading(false);
    }

    useEffect(() => {
        auth();
    }, []);

    if (loading) return <>LOADING...</>;

    return (
        <div className={`layout-container ${isDarkMode ? 'dark-theme' : 'light-theme'}`}>
            <AppNavbar />
            <div className="main-content">
                <div className="page-content">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default Layout;